var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.articleView)?_c('Topics',{attrs:{"articles":_vm.articles},on:{"view-article":_vm.viewArticle}}):_c('ViewTopic',{attrs:{"articleHTML":_vm.articleHTML,"loadingArticle":_vm.loadingArticle},on:{"go-back":_vm.viewFAQ}})}
var staticRenderFns = []

export { render, staticRenderFns }